import { useRef, useState } from "react";

import classNames from "classnames";

import type { ApiMagentoPriceTier } from "@jti/magento-types";
import { useOutsideClick } from "@jti/ui/hooks/useOutsideClick";

import ProductMultiplierHeader from "./ProductMultiplierHeader";
import ProductMultiplierItem from "./ProductMultiplierItem";

import "./ProductMultiplier.scss";

type ProductMultiplierType = {
  priceTiers: Array<ApiMagentoPriceTier>;
};

const ProductMultiplier = ({ priceTiers }: ProductMultiplierType) => {
  const dropdownRef = useRef<any>(null);
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen((isOpen) => !isOpen);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    const { key } = event;
    if (key === "Enter" || key === "ArrowDown") {
      setIsOpen(true);
      return;
    }
    if (key === "Escape") {
      setIsOpen(false);
    }
  };

  const className = classNames("product-multiplier", {
    "product-multiplier--open": isOpen,
  });

  const handleMultiplierItemClick = () => {
    setIsOpen(false);
  };

  useOutsideClick(dropdownRef, () => setIsOpen(false));

  return (
    <div className="product-multiplier__wrapper">
      <div ref={dropdownRef} data-testid="product-multiplier" className={className}>
        <ProductMultiplierHeader handleKeyDown={handleKeyDown} toggleDropdown={toggleDropdown} />
        <ul className="product-multiplier__list">
          {priceTiers.map((priceTier) => (
            <ProductMultiplierItem
              key={priceTier.final_price.value}
              item={priceTier}
              onItemClick={handleMultiplierItemClick}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProductMultiplier;
